import { Component } from '@angular/core';

@Component({
  templateUrl: './no-scenario-selected.component.html',
  styleUrls: ['./no-scenario-selected.component.scss']
})
export class NoScenarioSelectedComponent {

}
